import DashboardLayout from 'src/pages/Layout/DashboardLayout.vue';
import AuthLayout from 'src/pages/Auth/AuthLayout.vue';
// import NewLogin from 'src/pages/Auth/NewLogin.vue';
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue';

// Attendace pages
const AttendanceOverview = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Attendance/AttendanceOverview.vue');

const AttendanceAnalytics = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Attendance/Analytics.vue');

const AttendanceReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Attendance/ReportPage/AttendanceReport.vue');

const AttendanceSummary = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Attendance/ReportPage/AttendanceSummary.vue');

const MobileReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Attendance/ReportPage/MobileReport.vue');

const ScheduleEdit = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Attendance/ScheduleEdit.vue');

const ScheduleEditForm = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Attendance/ScheduleEditForm.vue');

const EmployeeManagement = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Attendance/EmployeeManagement.vue');

const EmployeeManagementForm = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Attendance/EmployeeManagementForm.vue');  

const ShiftCodeManagement = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Attendance/ShiftCodeManagement.vue');

const ShiftCodeManagementForm = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Attendance/ShiftCodeManagementForm.vue');

// Fleet Monitoring pages
const VehicleOverview = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/VehicleOverview.vue');

const VehicleGraph = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/VehicleGraph.vue');

const TotalVehicleReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/ReportPage/TotalVehicleReport.vue');

const BreakdownReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/ReportPage/BreakdownReport.vue');

const ReplacementReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/ReportPage/ReplacementReport.vue');

const AvailabilityReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/ReportPage/AvailabilityReport.vue');

const UnservicedReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/ReportPage/UnservicedReport.vue');

const RequirementReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/ReportPage/RequirementReport.vue');

const PercentAvailabilityReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/ReportPage/PercentAvailabilityReport.vue');

const VehicleMaintenance = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/VehicleMaintenance.vue');

const VehicleRequirement = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/VehicleRequirement.vue');

const VehicleSite = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/VehicleSite.vue');

const VehicleReplacement = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/VehicleReplacement.vue');

const VehicleSearch = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/VehicleSearch.vue');

const VehiclesRegistration = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/VehiclesRegistration.vue');

const RegisterVehicle = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/RegisterVehicle.vue');

const RegisterReplacement = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/RegisterReplacement.vue');

const UpdateVehicle = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Fleet/UpdateVehicle.vue');

// Green Card
const Overview = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/Overview.vue');

const Analytics = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/Analytics.vue');

const ScheduleActual = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/ReportPage/ScheduleActual.vue');

const MissCollection = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/ReportPage/MissCollection.vue');

const ScheduleConsistency = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/ReportPage/ScheduleConsistency.vue');

const CustomerRating = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/ReportPage/CustomerRating.vue');

const CustomerReview = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/ReportPage/CustomerReview.vue');

const InspectionReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/ReportPage/InspectionReport.vue');

const PickupQR = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/PickupQR.vue');

const CustomerManagement = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/CustomerUpdate/CustomerUpdate.vue');

const PickupPointUpdate = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/CustomerUpdate/PickupPointUpdate.vue');

const PickupPointAdd = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/CustomerUpdate/PickupPointAdd.vue');

const PickupPointForm = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/CustomerUpdate/PickupPointForm.vue');

const CustomerRegistration = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/GreenCard/CustomerRegistration/CustomerRegistration.vue');

// Asset pages
const AssetOverview = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/AssetOverview.vue');

const AssetGraph = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/AssetGraph.vue');

const AssetRegistration = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/AssetRegistration.vue');

  const AssetUpdate = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/AssetUpdate.vue');

const AssetManagement = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/AssetManagement.vue');

const AssetQR = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/AssetQR.vue');

const AssetDetailsReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/ReportPage/AssetDetailsReport.vue');

const AssetLocationReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/ReportPage/AssetLocationReport.vue');

const AssetRepairReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/ReportPage/AssetRepairReport.vue');

const PMMMaintenaceReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/ReportPage/PMMMaintenaceReport.vue');

const PPMDoneReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/ReportPage/PPMDoneReport.vue');

const PPMOverdueReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/ReportPage/PPMOverdueReport.vue');

const RelocationRequest = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/RelocationRequest.vue');

const RelocationApproval = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/RelocationApproval.vue');

const CorrectMaintenance = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Asset/ReportPage/CorrectMaintenance.vue'); 

// Incident Report 
const IncidentOverview = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/IncidentReport/IncidentOverview.vue');

const NewJKKP = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/IncidentReport/NewJKKP.vue');

const UpdateJKKP = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/IncidentReport/UpdateJKKP.vue');

const NewInvestigation = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/IncidentReport/NewInvestigation.vue');

const UpdateInvestigation = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/IncidentReport/UpdateInvestigation.vue');

const GenerateReport = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/IncidentReport/GenerateReport.vue');

const FollowUp = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/IncidentReport/FollowUp.vue');

const FollowUpForm = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/IncidentReport/FollowUpForm.vue');

const UserRegistration = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/UserRegistration/UserRegistration.vue');

const UserManagement = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/UserRegistration/UserManagement.vue');

const Settings = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Settings/Settings.vue');

// CEMS
const CEMSOverview = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/CEMS/Overview.vue');

const CEMSAnalytics = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/CEMS/Analytics.vue');

const CEMSSetting = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/CEMS/Setting.vue');

// CMMS
const CMMSOverview = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/CMMS/Overview.vue');

const CMMSAnalytics = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/CMMS/Analytic.vue');


// Scada
const ScadaOverview = () => 
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Scada/Overview.vue');

const ScadaAnalytic = () => 
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Scada/Analytic2.vue');

// Weighbridge
const WeighbridgeOverview = () => 
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Weigbrige/Overview.vue');

const WeighbridgeAnalytic = () => 
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Weigbrige/Analytic.vue');

const WeighbridgeManagement = () => 
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Weigbrige/Management.vue');

const WeighbridgeRegistration = () => 
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Weigbrige/WeigbrigeRegistration.vue');

const WeeklyDomesticWasteReport = () => 
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Weigbrige/Report/Weekly/DomesticWaste.vue');

const WeeklyBulkyWasteReport = () => 
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Weigbrige/Report/Weekly/BulkyWaste.vue');

const MonthlyDomesticWasteReport = () => 
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Weigbrige/Report/Monthly/DomesticWaste.vue');

const MonthlyBulkyWasteReport = () => 
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Weigbrige/Report/Monthly/BulkyWaste.vue');

const MonthlyTotalTonnageReport = () => 
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Weigbrige/Report/Monthly/TotalTonnage.vue');

  const MonthlySAS = () => 
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Weigbrige/Report/Monthly/SAS.vue');

import Widgets from 'src/pages/Widgets.vue';

//admin route
let adminMenu = {

  path: '/admin',
  component: DashboardLayout,
  redirect: '/admin',
};


let loginRoute = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
};

const routes = [
  {
    path: '/',
    redirect: '/newlogin',
    name: 'Login',
  },
  loginRoute,
  adminMenu,
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/Attendance',
    name: 'Dashboard',
    children: [
      {
        path: '/Settings',
        name: 'Settings',
        components: { default: Settings },
      },
      // ATTENDANCE
      {
        path: '/Attendance/AttendanceOverview',
        name: 'Attendance Overview',
        components: { default: AttendanceOverview }
      },
      {
        path: '/Attendance/Analytic',
        name: 'Attendance Analytic',
        components: { default: AttendanceAnalytics }
      },
      {
        path: '/Attendance/Report/Overall',
        name: 'Attendance Report',
        components: { default: AttendanceReport }
      },
      {
        path: '/Attendance/Report/Summary',
        name: 'Attendance Summary',
        components: { default: AttendanceSummary }
      },
      {
        path: '/Attendance/Report/Mobile',
        name: 'Mobile Report',
        components: { default: MobileReport }
      },
      {
        path: '/Attendance/ScheduleEdit',
        name: 'Schedule Edit',
        components: { default: ScheduleEdit }
      },
      {
        path: '/Attendance/ScheduleEditForm',
        name: 'Schedule Edit Form',
        components: { default: ScheduleEditForm }
      },
      {
        path: '/Attendance/EmployeeManagement',
        name: 'Employee Management',
        components: { default: EmployeeManagement }
      },
      {
        path: '/Attendance/EmployeeManagementForm',
        name: 'Employee Management Form',
        components: { default: EmployeeManagementForm }
      },
      {
        path: '/Attendance/ShiftCodeManagement',
        name: 'Shift Code Management',
        components: { default: ShiftCodeManagement }
      },
      {
        path: '/Attendance/ShiftCodeManagementForm',
        name: 'Shift Code Management Form',
        components: { default: ShiftCodeManagementForm }
      },
      // FLEET MAINTENANCE
      {
        path: '/Fleet/Overview',
        name: 'Vehicle Overview',
        components: { default: VehicleOverview }
      },
      {
        path: '/Fleet/Graph',
        name: 'Vehicle Graph',
        components: { default: VehicleGraph }
      },
      {
        path: '/Fleet/Report/TotalVehicleReport',
        name: 'Total Vehicle Report',
        components: { default: TotalVehicleReport }
      },
      {
        path: '/Fleet/Report/BreakdownReport',
        name: 'Breakdown Report',
        components: { default: BreakdownReport }
      },
      {
        path: '/Fleet/Report/ReplacementReport',
        name: 'Replacement Report',
        components: { default: ReplacementReport }
      },
      {
        path: '/Fleet/Report/AvailabilityReport',
        name: 'Availability Report',
        components: { default: AvailabilityReport }
      },
      {
        path: '/Fleet/Report/PercentAvailabilityReport',
        name: 'Percentage Availability Report',
        components: { default: PercentAvailabilityReport }
      },
      {
        path: '/Fleet/Report/UnservicedReport',
        name: 'Unserviced Report',
        components: { default: UnservicedReport }
      },
      {
        path: '/Fleet/Report/RequirementReport',
        name: 'Requirement Report',
        components: { default: RequirementReport }
      },
      {
        path: '/Fleet/VehicleMaintenance',
        name: 'Vehicle Maintenance',
        components: { default: VehicleMaintenance }
      },
      {
        path: '/Fleet/VehicleRequirement',
        name: 'Vehicle Requirement',
        components: { default: VehicleRequirement }
      },
      {
        path: '/Fleet/VehicleSite',
        name: 'Vehicle Site',
        components: { default: VehicleSite }
      },
      {
        path: '/Fleet/VehicleReplacement',
        name: 'Vehicle Replacement',
        components: { default: VehicleReplacement }
      },
      {
        path: '/Fleet/VehicleSearch',
        name: 'Vehicle Search',
        components: { default: VehicleSearch }
      },
      {
        path: '/Fleet/VehicleUpdate/:vehregno',
        name: 'Vehicle Update',
        components: { default: UpdateVehicle }
      },
      {
        path: '/Fleet/VehicleRegistration',
        name: 'Vehicles Registration',
        components: { default: VehiclesRegistration }
      },
      {
        path: '/Fleet/RegisterVehicle',
        name: 'Register Vehicle',
        components: { default: RegisterVehicle }
      },
      {
        path: '/Fleet/RegisterReplacement/:replaceveh',
        name: 'Register Replacement Vehicle',
        components: { default: RegisterReplacement }
      },
      {
        path: '/UserRegistration',
        name: 'User Registration',
        components: { default: UserRegistration }
      },
      {
        path: '/UserManagement',
        name: 'User Management',
        components: { default: UserManagement }
      },
      {
        path: '/Asset/AssetOverview',
        name: 'Asset Overview',
        components: { default: AssetOverview }
      },
      {
        path: '/Asset/AssetGraph',
        name: 'Asset Graph',
        components: { default: AssetGraph }
      },
      {
        path: '/Asset/AssetRegistration',
        name: 'Asset Registration',
        components: { default: AssetRegistration }
      },
      {
        path: '/Asset/AssetUpdate',
        name: 'Asset Update',
        components: { default: AssetUpdate }
      },
      {
        path: '/Asset/AssetManagement',
        name: 'Asset Management',
        components: { default: AssetManagement }
      },
      {
        path: '/Asset/AssetQR',
        name: 'Asset QR',
        components: { default: AssetQR }
      },
      {
        path: '/Asset/Report/AssetDetailsReport',
        name: 'Asset Details Report',
        components: { default: AssetDetailsReport }
      },
      {
        path: '/Asset/Report/AssetLocationReport',
        name: 'Asset Location Report',
        components: { default: AssetLocationReport }
      },
      {
        path: '/Asset/Report/AssetRepairReport',
        name: 'Asset Repair Report',
        components: { default: AssetRepairReport }
      },
      {
        path: '/Asset/Report/PMMMaintenaceReport',
        name: 'PMM Report',
        components: { default: PMMMaintenaceReport }
      },
      {
        path: '/Asset/Report/PPMDoneReport',
        name: 'PPM Done Report',
        components: { default: PPMDoneReport }
      },
      {
        path: '/Asset/Report/PPMOverdueReport',
        name: 'PPM Overdue Report',
        components: { default: PPMOverdueReport }
      },
      {
        path: '/Asset/RelocationRequest',
        name: 'Asset Relocation Request',
        components: { default: RelocationRequest }
      },
      {
        path: '/Asset/Report/CorrectMaintenance',
        name: 'Asset Under-repair Report',
        components: { default: CorrectMaintenance }
      },
      {
        path: '/Asset/RelocationApproval',
        name: 'Asset Relocation Approval',
        components: { default: RelocationApproval }
      },
      // Green Card
      {
        path: '/Greencard/Overview',
        name: 'Green Card',
        components: { default: Overview }
      },
      {
        path: '/Greencard/Analytics',
        name: 'Analytics',
        components: { default: Analytics }
      },
      {
        path: '/Greencard/Report/ScheduleActual',
        name: 'Schedule Actual',
        components: { default: ScheduleActual }
      },
      {
        path: '/Greencard/Report/ScheduleConsistency',
        name: 'Schedule Consistency',
        components: { default: ScheduleConsistency }
      },
      {
        path: '/Greencard/Report/CustomerRating',
        name: 'Customer Rating',
        components: { default: CustomerRating }
      },
      {
        path: '/Greencard/Report/CustomerReview',
        name: 'Customer Review',
        components: { default: CustomerReview }
      },
      {
        path: '/Greencard/Report/InspectionReport',
        name: 'Inspection Report',
        components: { default: InspectionReport }
      },
      {
        path: '/Greencard/Report/MissCollection',
        name: 'Miss Collection',
        components: { default: MissCollection }
      },
      {
        path: '/Greencard/CustomerManagement',
        name: 'Customer Update',
        components: { default: CustomerManagement }
      },
      {
        path: '/Greencard/PickupPointUpdate/:custid',
        name: 'Pickup Point Update',
        components: { default: PickupPointUpdate }
      },
      {
        path: '/Greencard/PickupPointAdd/:custid',
        name: 'Pickup Point Add',
        components: { default: PickupPointAdd }
      },
      {
        path: '/Greencard/PickupPointForm/:pickupid',
        name: 'Pickup Point List',
        components: { default: PickupPointForm }
      },
      {
        path: '/Greencard/CustomerRegistration',
        name: 'Customer Registration',
        components: { default: CustomerRegistration }
      },
      {
        path: '/Greencard/PickupQR',
        name: 'Pickup QR',
        components: { default: PickupQR }
      },
      // Incident Report
      {
        path: '/IncidentReport/IncidentOverview',
        name: 'Incident Overview',
        components: { default: IncidentOverview }
      },
      {
        path: '/IncidentReport/NewJKKP',
        name: 'New JKKP',
        components: { default: NewJKKP }
      },
      {
        path: '/IncidentReport/UpdateJKKP',
        name: 'Update JKKP',
        components: { default: UpdateJKKP }
      },
      {
        path: '/IncidentReport/UpdateInvestigation',
        name: 'Update Investigation',
        components: { default: UpdateInvestigation }
      },
      {
        path: '/IncidentReport/NewInvestigation',
        name: 'New Investigation',
        components: { default: NewInvestigation }
      },
      {
        path: '/IncidentReport/GenerateReport',
        name: 'Generate Report',
        components: { default: GenerateReport }
      },
      {
        path: '/IncidentReport/FollowUp',
        name: 'Follow Up',
        components: { default: FollowUp }
      },
      {
        path: '/IncidentReport/FollowUp/:instid',
        name: 'Edit Follow Up',
        components: { default: FollowUpForm }
      },
      // CEMS
      {
        path: '/CEMS/Overview',
        name: 'CEMS Overview',
        components: { default: CEMSOverview }
      },
      {
        path: '/CEMS/Analytic',
        name: 'CEMS Analytic',
        components: { default: CEMSAnalytics }
      },
      // {
      //   path: '/CEMS/Setting',
      //   name: 'CEMS Setting',
      //   components: { default: CEMSSetting }
        
      // },
      // CMMS
      {
        path: '/CMMS/Overview',
        name: 'CMMS Overview',
        components: { default: CMMSOverview }
      },
      {
        path: '/CMMS/Analytic',
        name: 'CMMS Analytic',
        components: { default: CMMSAnalytics}
      },
      // Scada
      {
        path: '/Scada/Overview',
        name: 'Scada Overview',
        components: { default: ScadaOverview }
      },
      {
        path: '/Scada/Analytic',
        name: 'Scada Analytic',
        components: { default: ScadaAnalytic}
      },
       // Weigbrige
       {
        path: '/Weighbridge/Overview',
        name: 'Weighbridge Overview',
        components: { default: WeighbridgeOverview }
      },
      {
        path: '/Weighbridge/Analytic',
        name: 'Weighbridge Analytic',
        components: { default: WeighbridgeAnalytic}
      },
      {
        path: '/Weighbridge/Management',
        name: 'Weightbridge Management',
        components: { default: WeighbridgeManagement}
        
      },
      {
        path: '/Weighbridge/Registration',
        name: 'Weighbridge Registration',
        components: { default: WeighbridgeRegistration}
      },
      {
        path: '/Weighbridge/Report/Weekly/DomesticWaste',
        name: 'Weekly Domestic Waste Report',
        components: { default: WeeklyDomesticWasteReport}
      },
      {
        path: '/Weighbridge/Report/Weekly/BulkyWaste',
        name: 'Weekly Bulky Waste Report',
        components: { default: WeeklyBulkyWasteReport}
      },
      {
        path: '/Weighbridge/Report/Monthly/DomesticWaste',
        name: 'Monthly Domestic Waste Report',
        components: { default: MonthlyDomesticWasteReport}
      },
      {
        path: '/Weighbridge/Report/Monthly/BulkyWaste',
        name: 'Monthly Bulky Waste Report',
        components: { default: MonthlyBulkyWasteReport}
      },
      {
        path: '/Weighbridge/Report/Monthly/TotalTonnageReport',
        name: 'Monthly Total Tonnage Report',
        components: { default: MonthlyTotalTonnageReport}
      },
      {
        path: '/Weighbridge/Report/Monthly/SASReport',
        name: 'monthly SAS Report',
        components: { default: MonthlySAS}
      },
      
      // {
      //   path: '/newlogin',
      //   name: 'Login',
      //   components: { default: NewLogin }
      // }
    ]
  },
  { path: '*', component: NotFound }
];

export default routes;
